<template>
<div>
  <div class="col-md-12">
    <canvas height="250" id="source-chart"></canvas>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import Chart from 'chart.js'
export default {
  name: 'bookingSuccess',
  data() {
    return {
      loading: false,
      chartData: [],
      labelData: []
    //   values: [[10, 2, 15, 17]],
    };
  },
  watch:{
    // endDate(){
    //   this.loadData()
    // }
  },
  mounted() {
  },
  created(){
      this.endDate = moment().format('YYYY-MM-DD')
      this.loadData()
  },
  methods:{ 
    async loadData() {
      try {
        var bookingStats = await this.$store.dispatch("sucess_source_list")
        this.chartData = [bookingStats[1].success_android,bookingStats[2].success_web,bookingStats[3].success_ios]
        this.labelData = ["Android", "Web", "IOS"]
      } finally {
        const ctx = document.getElementById('source-chart');
        var successSource = {
          type: 'bar',
          data: {
            labels: this.labelData,
            datasets: [
              {
                data: this.chartData,
                backgroundColor:'rgba(75, 192, 192, 0.2)',
                borderColor:'rgb(54, 162, 235)',
                borderWidth: 2
              },
            ]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                      drawBorder: false
                  },
                }
              ],
              xAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(128,0,0,0.05)",
                      drawBorder: false
                  },
                }
              ]
            }
          }
        }
        new Chart(ctx, successSource);
      }
    }
  },
  computed:{}
};
</script>

<style></style>